import {Alert, Box, Button} from "@mui/material";
import {ArrowBackIosNew} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import CreateFilling from "./createFilling/CreateFilling";
import {itemAPI} from "../../../services/ItemServices";
import {fillingAPI} from "../../../services/FillingServices";
import {SaveFillingGuidRequest} from "../../../models/Recipe/Filling/IFillingGuid";
import {recipeAPI} from "../../../services/RecipeServices";
import {useAppTranslation} from "@mybake/ui/hooks/useAppTranslation";
import {getApiErrorMessage} from '../../../common/apiErrors';
import {ContentSkeleton} from '../../common/loading/ContentSkeleton';

export const FillingCreatePage = () => {
    const navigate = useNavigate();
    const handleCreateMode = () => {
        navigate("..", {relative: "path"});
    }
    const {t} = useAppTranslation();
    const {
        data: itemsData,
        isError: itemsIsError,
        isLoading: itemsIsLoading,
        isSuccess: itemsIsSuccess
    } = itemAPI.useGetAllItemsV2Query();

    const {
        data: recipes,
        isLoading: isLoadingRecipe,
        error: getRecipeError,
        isSuccess: isSuccessRecipe
    } = recipeAPI.useGetRecipesV2AllLightQuery();

    const [createFilling] = fillingAPI.useCreateFillingV2Mutation();
    const handleCreateFilling = async (formData: SaveFillingGuidRequest) => {
        try {
            await createFilling(formData).unwrap();
            handleCreateMode();
        } catch (error) { throw error; }
    }

    return <Box sx={{width: '100%'}}>
        <Button variant="outlined" startIcon={<ArrowBackIosNew/>}
                onClick={() => navigate("..", {relative: "path"})}>
            {t('recipes:back_to_fillings')}
        </Button>
        {(itemsIsLoading || isLoadingRecipe) && <ContentSkeleton variant="form"/>}
        {(itemsIsError || getRecipeError) && <Alert severity="error" sx={{mt: 2}}>{getApiErrorMessage(getRecipeError || {status: 500}, t)}</Alert>}
        {itemsIsSuccess && isSuccessRecipe && <CreateFilling key={'isCreateFillingMode'} items={itemsData} recipes={recipes} onSubmit={handleCreateFilling}/>}
    </Box>
}
